module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "main-footer"
  }, [_c('strong', [_vm._v("Copyright © " + _vm._s(_vm.year) + "\n  "), _c('a', {
    attrs: {
      "href": "https://gaspesie.net",
      "target": "_blank"
    }
  }, [_vm._v("InteliSoft Informatique inc.")])]), _vm._v(" Tous droits réservés.\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d5ae346c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/DashFooter.vue
// module id = 1345
// module chunks = 1